<template>
    <section class="section-bottom-container-xs">
        <button class="section-bottom-btn-project-summary-xs" @click="$emit('select-summary-btn')">
            Project Overview
        </button>
        <button class="section-bottom-btn-save-changes-xs" @click="$emit('apply-event')">
            <img v-show="savingService" src="@/assets/spinner.svg" /> {{ saveButtonTextVS }}
        </button>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        savingService: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'saveButtonTextVS',
            'orderMediaDetailsVS',
            'multipleCatalogueServiceId',
            'VSReferencePhoto',
        ]),
    },
};
</script>

<style lang="scss" scoped>
.section-bottom {
    &-container-xs {
        @include centerByFlex;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 77px;
        display: flex;
        justify-content: space-between;
        background: linear-gradient(
            0deg,
            #fcfcfc 3.53%,
            rgba(252, 252, 252, 0.9) 32.76%,
            rgba(252, 252, 252, 0.8) 50.9%,
            rgba(252, 252, 252, 0.2) 75.08%,
            rgba(252, 252, 252, 0) 96.75%
        );
        z-index: 10;
        padding: 0 16px;
    }
    &-btn {
        &-save-changes-xs {
            @include nextBtn(120px, 32px);
            font-size: 14px;
            font-weight: bold;
        }
        &-project-summary-xs {
            @include backBtn(140px, 32px);
            font-size: 14px;
        }
    }
}
</style>
